import { CircleAlert, CircleCheck, Info } from 'lucide-react'
import { useStaat, zet } from '../lib/staat'

/** Korte meldingen rechtsonder. Een fout blijft langer staan; klik = weg. */
export default function Meldingen() {
  const meldingen = useStaat((s) => s.meldingen)
  /* Het vak staat er altijd, ook leeg: een schermlezer leest een live-gebied
     alleen voor als het er al was voordat de tekst erin kwam. Kwam het pas
     mét de eerste melding, dan bleef die eerste melding stil. */
  return (
    <div className="meldingen" role="status" aria-live="polite">
      {meldingen.map((m) => (
        <button key={m.id} type="button" className={`toast ${m.soort}`}
          onClick={() => zet({ meldingen: meldingen.filter((x) => x.id !== m.id) })}>
          {m.soort === 'fout' ? <CircleAlert size={16} /> : m.soort === 'ok' ? <CircleCheck size={16} /> : <Info size={16} />}
          <span>{m.tekst}</span>
        </button>
      ))}
    </div>
  )
}
